import React from "react"

import { SilResultSafetyFunction } from "server/models"
import {
    IEC_61508_1998,
    IEC_61508_2010,
    ISA_TR84_2002,
    ISA_TR84_2022,
    VDI_VDE_2180_2019,
    NO_ARCHITECTURAL_CONSTRAINTS,
    NO_DANGEROUS_FAILURE,
    NO_SAFE_FAILURE,
} from "const"
import { SilCalculationMethod } from "client/utils"
import { LangType, UserSettings } from "client/store"

import { Iec615081998, Iec615081998PdfExport } from "./iec_61508_1998"
import { Iec615082010, Iec615082010PdfExport } from "./iec_61508_2010"
import { IsaTr842002, IsaTr842002PdfExport } from "./isa_tr84_2002"
import { IsaTr842022, IsaTr842022PdfExport } from "./isa_tr84_2022"
import { VdiVde21802019, VdiVde21802019PdfExport } from "./vdi_vde_2180_2019"


interface SubsystemArchitectureProps {
    resultSafetyFunction: SilResultSafetyFunction
}

const SubsystemArchitectureParameters = ({
    resultSafetyFunction,
}: SubsystemArchitectureProps) => {
    const subsystemList = resultSafetyFunction.subsystems || []

    let showArchitectureConstraints = true
    if (subsystemList[0] && subsystemList[0].architecturalConstraints === NO_ARCHITECTURAL_CONSTRAINTS) {
        showArchitectureConstraints = false
    }

    // important! get the subsystem list from the function!
    const {
        calculationMethodDangerous,
        calculationMethodSafe,
        subsystems,
    } = resultSafetyFunction

    // calculation method can be or dangerous or safe or "no dangerous/safe failure", never both
    let calculationMethod: SilCalculationMethod = null
    if (calculationMethodDangerous !== NO_DANGEROUS_FAILURE) calculationMethod = calculationMethodDangerous
    if (calculationMethodSafe !== NO_SAFE_FAILURE) calculationMethod = calculationMethodSafe


    if (calculationMethod === IEC_61508_1998) {
        return (
            <Iec615081998
                subsystemList={subsystems || []}
                showArchitectureConstraints={showArchitectureConstraints}
            />
        )
    }
    if (calculationMethod === IEC_61508_2010) {
        return (
            <Iec615082010
                subsystemList={subsystems || []}
                showArchitectureConstraints={showArchitectureConstraints}
            />
        )
    }
    if (calculationMethod === ISA_TR84_2002) {
        return (
            <IsaTr842002
                subsystemList={subsystems || []}
                showArchitectureConstraints={showArchitectureConstraints}
            />
        )
    }
    if (calculationMethod === ISA_TR84_2022) {
        return (
            <IsaTr842022
                subsystemList={subsystems || []}
                showArchitectureConstraints={showArchitectureConstraints}
                calculationMethodDangerous={calculationMethodDangerous === ISA_TR84_2022}
                calculationMethodSafe={calculationMethodSafe === ISA_TR84_2022}
            />
        )
    }
    if (calculationMethod === VDI_VDE_2180_2019) {
        return (
            <VdiVde21802019
                subsystemList={subsystems || []}
                showArchitectureConstraints={showArchitectureConstraints}
            />
        )
    }
    return null
}
export default SubsystemArchitectureParameters


export const SubsystemArchitectureParametersPdfExport = (
    resultSafetyFunction: SilResultSafetyFunction,
    userSettings: UserSettings,
    lang: LangType,
) => {
    // eslint-disable-next-line react/destructuring-assignment
    const subsystemList = resultSafetyFunction.subsystems || []

    let showArchitectureConstraints = true
    if (subsystemList[0] && subsystemList[0].architecturalConstraints === NO_ARCHITECTURAL_CONSTRAINTS) {
        showArchitectureConstraints = false
    }

    // important! get the subsystem list from the function!
    const {
        calculationMethodDangerous,
        calculationMethodSafe,
        subsystems,
    } = resultSafetyFunction

    // calculation method can be or dangerous or safe or "no dangerous/safe failure", never both
    let calculationMethod: SilCalculationMethod = null
    if (calculationMethodDangerous !== NO_DANGEROUS_FAILURE) calculationMethod = calculationMethodDangerous
    if (calculationMethodSafe !== NO_SAFE_FAILURE) calculationMethod = calculationMethodSafe

    if (calculationMethod === IEC_61508_1998) {
        return Iec615081998PdfExport(
            subsystems || [],
            showArchitectureConstraints,
            userSettings,
            lang,
        )
    }
    if (calculationMethod === IEC_61508_2010) {
        return Iec615082010PdfExport(
            subsystems || [],
            showArchitectureConstraints,
            userSettings,
            lang,
        )
    }
    if (calculationMethod === ISA_TR84_2002) {
        return IsaTr842002PdfExport(
            subsystems || [],
            showArchitectureConstraints,
            userSettings,
            lang,
        )
    }
    if (calculationMethod === ISA_TR84_2022) {
        return IsaTr842022PdfExport(
            subsystems || [],
            showArchitectureConstraints,
            calculationMethodDangerous === ISA_TR84_2022,
            calculationMethodSafe === ISA_TR84_2022,
            userSettings,
            lang,
        )
    }
    if (calculationMethod === VDI_VDE_2180_2019) {
        return VdiVde21802019PdfExport(
            subsystems || [],
            showArchitectureConstraints,
            userSettings,
            lang,
        )
    }
    return null
}
